import moment from 'moment';

export const redondear = (numero, redondeo) => {
  // Redondear por valor de redondeo
  let value = numero;
  if (numero > redondeo) {
    value = Math.ceil(numero / redondeo).toFixed(0) * redondeo;
  }
  return value;
};

export const formatearAMillones = (montoParam) => {
  const zeroCount = 6;
  // eslint-disable-next-line no-restricted-properties
  return Math.round(parseInt(montoParam, 10) / 10 ** zeroCount) * 1000000;
};

const redondearYCadena = (numero, redondeo, numeroDeDecimales) => {
  // Redondear por valor de redondeo y convertir a cadena
  const value = redondear(numero, redondeo);
  return parseFloat(value).toFixed(numeroDeDecimales);
};
const formatoGs = (numero, redondeo, posicionSimbolo = 'i') => {
  const opciones = {
    numeroDeDecimales: 0,
    separadorDecimal: ',',
    separadorMiles: '.',
    simbolo: 'Gs.',
    posicionSimbolo
  };
  const CIFRAS_MILES = 3;
  const numeroComoCadena = redondearYCadena(
    numero,
    redondeo,
    opciones.numeroDeDecimales
  );

  // Comenzar desde la izquierda del separador o desde el final de la cadena si no se proporciona
  let posicionDelSeparador = numeroComoCadena.indexOf(
    opciones.separadorDecimal
  );
  if (posicionDelSeparador === -1)
    posicionDelSeparador = numeroComoCadena.length;
  let formateadoSinDecimales = '';
  let indice = posicionDelSeparador;
  // Ir cortando desde la derecha de 3 en 3, y concatenar en una nueva cadena
  while (indice >= 0) {
    const limiteInferior = indice - CIFRAS_MILES;
    // Agregar separador si cortamos más de 3
    formateadoSinDecimales =
      (limiteInferior > 0 ? opciones.separadorMiles : '') +
      numeroComoCadena.substring(limiteInferior, indice) +
      formateadoSinDecimales;
    indice -= CIFRAS_MILES;
  }
  const formateadoSinSimbolo = `${formateadoSinDecimales}${numeroComoCadena.substr(
    posicionDelSeparador,
    opciones.numeroDeDecimales + 1
  )}`;
  // return opciones.posicionSimbolo === 'i' ? `${opciones.simbolo} ` + formateadoSinSimbolo : formateadoSinSimbolo + ` ${opciones.simbolo}`;
  return `${opciones.simbolo} ${formateadoSinSimbolo}`;
};

export default formatoGs;

export const formatNumber = (rawValue, cfg) => {
  const defaultConfig = {
    precision: 0,
    separator: ',',
    delimiter: '.',
    unit: ''
  };

  const config = cfg || defaultConfig;

  if (!rawValue && rawValue !== 0) {
    return '-';
  }

  const minChars = '0'.length + config.precision;

  let result = `${rawValue}`;

  if (result.length < minChars) {
    const numbers = minChars - result.length;
    const leftZeroPad = '0'.repeat(numbers);
    result = `${leftZeroPad}${result}`;
  }

  let beforeSeparator = result.slice(0, result.length - config.precision);
  const afterSeparator = result.slice(result.length - config.precision);

  if (beforeSeparator.length > 3) {
    const chars = beforeSeparator.split('').reverse();
    let withDots = '';

    // eslint-disable-next-line no-plusplus
    for (let i = chars.length - 1; i >= 0; i--) {
      const char = chars[i];
      const dot = i % 3 === 0 ? config.delimiter : '';
      withDots = `${withDots}${char}${dot}`;
    }

    withDots = withDots.substring(0, withDots.length - 1);
    beforeSeparator = withDots;
  }

  const separatorOnwards = afterSeparator
    ? config.separator + afterSeparator
    : '';
  result = beforeSeparator + separatorOnwards;

  if (config.unit) {
    result = `${config.unit} ${result}`;
  }

  return result;
};

/**
 * Converts a date to DD-MM-YYYY format
 *
 * @param Date value
 * @returns {string} Formatted date string
 */
export const formatDate = (value) => {
  if (!value) {
    return '-';
  }
  return moment(value).format('DD/MM/YYYY');
};

/**
 * Converts a datetime to a DD-MM-YYYY HH:mm formatted string
 *
 * @param Datetime value
 * @returns {string} Formatted date string
 */
export const formatDateTime = (value) => {
  if (!value) {
    return '-';
  }
  return moment(value).format('DD/MM/YYYY HH:mm');
};

/**
 * Converts a boolean value to string
 *
 * @param Boolean value
 * @returns {string} Formatted boolean string
 */
export const formatBoolean = (value) => {
  if (value === undefined || value === null) {
    return '-';
  }
  if (value === true || value === 'true') {
    return 'Sí';
  }
  if (value === false || value === 'false') {
    return 'No';
  }
  return '-';
};

export const formatoMonedaGenerico = (moneda, numero, redondeo) => {
  // Convierte valor numerico entero o decimal a formato de Moneda. Ej: 10 -> Usd. 10.00
  let opciones = {
    numeroDeDecimales: 0,
    separadorDecimal: ',',
    separadorMiles: '.',
    simbolo: 'Gs. ',
    posicionSimbolo: 'i'
  };
  const CIFRAS_MILES = 3;
  if (moneda) {
    if (moneda.codigo === 'gs') {
      opciones = {
        numeroDeDecimales: 0,
        separadorDecimal: ',',
        separadorMiles: '.',
        simbolo: `${moneda.simbolo} `,
        posicionSimbolo: 'i'
      };
    } else if (moneda.codigo === 'usd') {
      opciones = {
        numeroDeDecimales: 2,
        separadorDecimal: '.',
        separadorMiles: ',',
        simbolo: `${moneda.simbolo} `,
        posicionSimbolo: 'i'
      };
    }
  }
  // Redondear por valor de redondeo y convertir a cadena
  let value = numero;
  if (numero > redondeo) {
    value = Math.ceil(numero / redondeo).toFixed(0) * redondeo;
  }
  const numeroComoCadena = parseFloat(value).toFixed(
    opciones.numeroDeDecimales
  );

  // Comenzar desde la izquierda del separador o desde el final de la cadena si no se proporciona
  let posicionDelSeparador = numeroComoCadena.indexOf(
    opciones.separadorDecimal
  );
  if (posicionDelSeparador === -1)
    posicionDelSeparador = numeroComoCadena.length;
  let formateadoSinDecimales = '';
  let indice = posicionDelSeparador;
  // Ir cortando desde la derecha de 3 en 3, y concatenar en una nueva cadena
  while (indice >= 0) {
    const limiteInferior = indice - CIFRAS_MILES;
    // Agregar separador si cortamos más de 3
    formateadoSinDecimales =
      (limiteInferior > 0 ? opciones.separadorMiles : '') +
      numeroComoCadena.substring(limiteInferior, indice) +
      formateadoSinDecimales;
    indice -= CIFRAS_MILES;
  }
  let formateadoSinSimbolo;

  if (Number.isNaN(Number(numeroComoCadena))) {
    formateadoSinSimbolo = '-';
  } else {
    formateadoSinSimbolo = `${formateadoSinDecimales}${numeroComoCadena.substr(
      posicionDelSeparador,
      opciones.numeroDeDecimales + 1
    )}`;
  }

  return opciones.posicionSimbolo === 'i'
    ? opciones.simbolo + formateadoSinSimbolo
    : formateadoSinSimbolo + opciones.simbolo;
};

export const replaceMontoMoneda = (monto) => {
  // Convierte formato de Moneda a valor numerico (entero o decimal). Ej: Usd. 3,250.50 -> 3250.50
  if (monto.includes('Gs')) {
    return monto.replace(/\D+/g, '') || '0';
  }
  if (monto.includes('Usd')) {
    // 'Usd. 0.001'
    return monto.replace(/([Usd].)+/g, '').replace(/[ ]*,[ ]*|[ ]+/g, '') || 0;
  }
  return '0';
};
